<template>
  <div>
    <p>
      {{ $t('giftgiver.assign.info_1') }}
      <span class="fw-600">{{ $t('giftgiver.assign.info_2') }}</span>
      {{ $t('giftgiver.assign.info_3') }}
    </p>
    <v-text-field
      v-model="giftgiverData.email"
      v-validate="validationRules.get('regex_email_without_polish')"
      class="required-field"
      :error-messages="errors.collect('regex_email_without_polish')"
      :label="$t('label.email')"
      data-vv-name="regex_email_without_polish"
      :data-vv-as="$t('label.email')"
      required
      inputmode="email"
      @input="trimEmail()"
    />
    <v-text-field
      v-model="giftgiverData.phone_number"
      v-validate="{ required: true, international_phone: true }"
      class="pt-0 mt-3 required-field"
      name="phone"
      :label="$t('label.phone')"
      data-vv-name="international_phone"
      :error-messages="errors.collect('international_phone')"
      :data-vv-as="$t('label.phone')"
      required
      type="tel"
      inputmode="tel"
      @input="trimPhoneNumber()"
      @focusout="trimPhoneNumber()"
    />
    <v-text-field
      v-model.trim="giftgiverData.first_name"
      v-validate="validationRules.get('first_name')"
      class="required-field"
      :error-messages="errors.collect('first_name')"
      :label="$t('label.first_name')"
      :data-vv-as="$t('label.first_name')"
      data-vv-name="first_name"
      required
    />
    <v-text-field
      v-model.trim="giftgiverData.last_name"
      v-validate="validationRules.get('last_name')"
      class="required-field"
      :error-messages="errors.collect('last_name')"
      :label="$t('label.last_name')"
      :data-vv-as="$t('label.last_name')"
      data-vv-name="last_name"
      required
    />
    <p class="mt-2">
      {{ $t('label.contact_form') }} {{ $t('message.optional') | brackets }}
    </p>
    <v-textarea
      v-model="giftgiverData.comment"
      v-validate="validationRules.get('giftgiverFormOfContact')"
      auto-grow
      class="mt-0 pt-0"
      :placeholder="$t('message.contact_preferences')"
      :error-messages="errors.collect('giftgiverFormOfContact')"
      :data-vv-as="' '"
      data-vv-name="giftgiverFormOfContact"
    />
    <p class="required-block mt-3 mb-0">
      {{ $t('giftgiver.assign.gift_creators') }}
    </p>
    <v-radio-group
      v-model="giftgiverData.category"
      v-validate="validationRules.get('radio_buttons')"
      :error-messages="errors.collect('radio_buttons')"
      :data-vv-as="' '"
      data-vv-name="radio_buttons"
    >
      <v-radio
        v-for="(creator, index) in creators"
        :key="index"
        :label="creator.description"
        :value="creator.id"
      />
    </v-radio-group>
    <div v-if="!hasGiftgiver">
      <p class="required-block mt-3 mb-0">
        {{ $t('giftgiver.assign.warehouse_list') }}
      </p>
      <v-select
        v-model="giftgiverData.chosen_warehouse"
        v-validate="validationRules.get('addWarehouseBaseParameters')"
        class="required-field"
        :items="publishedWarehouses"
        item-text="warehouse_name"
        item-value="warehouse_id"
        :error-messages="errors.collect('chosen_warehouse')"
        data-vv-name="chosen_warehouse"
        :data-vv-as="$t('label.warehouse')"
        required
        append-icon="expand_more"
      />
    </div>
    <div v-if="canEditGiftgiverData">
      <p class="required-block mt-3">
        {{ $t('giftgiver.edit.change_reason') }}
      </p>
      <v-textarea
        v-model="explanation"
        v-validate="validationRules.get('editReason')"
        auto-grow
        class="mt-0 pt-0"
        :error-messages="errors.collect('editReason')"
        :data-vv-as="' '"
        data-vv-name="editReason"
        required
      />
    </div>
  </div>
</template>

<script>
import validationRules from '@/constants/validationRules';
import filters from '@/constants/filters';
import { mapFields } from 'vuex-map-fields';

export default {
    name: 'AssignGiftgiverForm',
    filters: {
        ...filters
    },
    inject: ['$validator'],
    props: {
        canEditGiftgiverData: {
            type: Boolean,
            default: false
        },
        warehouses: {
            type: Array
        },
        hasGiftgiver: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules,
            WAREHOUSE_PUBLISHED_STATUS_ID: 20
        };
    },
    watch: {
        publishedWarehouses: {
            handler (val) {
                if (val && val.length === 1) {
                    this.giftgiverData.chosen_warehouse = val[0].warehouse_id;
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapFields('giftgiver', ['giftgiverData', 'explanation']),
        creators () {
            return this.$store.getters['giftgiver/getGiftgiverCreators'];
        },
        publishedWarehouses () {
            return this.warehouses.filter((el) => {
                return el.status && el.status.warehouse_status_id === this.WAREHOUSE_PUBLISHED_STATUS_ID;
            });
        }
    },
    methods: {
        trimEmail () {
            this.giftgiverData.email = this.giftgiverData.email.trim();
        },
        trimPhoneNumber () {
            this.giftgiverData.phone_number = this.giftgiverData.phone_number.replace(/ /g, '');
        }
    }
};
</script>

<style scoped></style>
